<template lang="pug">
div
  sticky(className="sub-navbar")
    el-button(type='primary' size='mini' icon='el-icon-upload' @click='onSaveCareers')
      | 保存
  .contents-container
    el-form.c-form(ref='form', :model='form', v-loading='LOADING')
      header.c-form__header
        h1 必須項目
      .c-form__body(v-if='dataloaded')
        section.c-form__item
          header.c-form__item__header
            h1 メイン画像
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='24')
                el-form-item
                  upload-multi(:form='form')
        section.c-form__item
          header.c-form__item__header.--c
            h1 説明文
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='24')
                el-form-item
                  el-input(v-model='form.description' placeholder='説明文を入力してください' type='textarea' :rows='15')
              el-col(:span='24')
                p.caption.u-margin__bottom--m マークアップタグを利用できます。
                  br
                  code 例：&lt;a href="https://www.google.com/" class="arrow"&gt;Google&lt;/a&gt;
        section.c-form__item
          header.c-form__item__header
            h1 条件（左サイド）
            .func
              el-button(size='small' type='primary' icon='el-icon-plus' @click='addCondition("conditions1")') 追加
              el-button(size='small' type='danger' icon='el-icon-delete' @click='delCondition("conditions1")' :disabled='form.conditions1.length < 1') 削除
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='24')
                el-form-item(v-for='(i, index) in form.conditions1' :key='`conditions1_${index}`')
                  el-input(v-model='form.conditions1[index].title' placeholder='タイトルを入力してください ' )
                  el-input(v-model='form.conditions1[index].body' placeholder='説明文を入力してください' type='textarea' :rows='3')
              el-col(:span='24')
                p.caption.u-margin__bottom--m 説明文にはマークアップタグを利用できます。
                  br
                  code 例：&lt;a href="https://www.google.com/" class="arrow"&gt;Google&lt;/a&gt;
        section.c-form__item
          header.c-form__item__header
            h1 条件（右サイド）
            .func
              el-button(size='small' type='primary' icon='el-icon-plus' @click='addCondition("conditions2")') 追加
              el-button(size='small' type='danger' icon='el-icon-delete' @click='delCondition("conditions2")' :disabled='form.conditions2.length < 1') 削除
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='24')
                el-form-item(v-for='(i, index) in form.conditions2' :key='`conditions1_${index}`')
                  el-input(v-model='form.conditions2[index].title' placeholder='タイトルを入力してください ' )
                  el-input(v-model='form.conditions2[index].body' placeholder='説明文を入力してください' type='textarea' :rows='3')
              el-col(:span='24')
                p.caption.u-margin__bottom--m 説明文にはマークアップタグを利用できます。
                  br
                  code 例：&lt;a href="https://www.google.com/" class="arrow"&gt;Google&lt;/a&gt;
        section.c-form__item
          header.c-form__item__header
            h1 募集職種
            .func
              el-button(size='small' type='primary' icon='el-icon-plus' @click='addJobs()') 追加
              el-button(size='small' type='danger' icon='el-icon-delete' @click='delJobs()' :disabled='form.jobs.length < 1') 削除
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='24')
                el-form-item(v-for='(i, index) in form.jobs' :key='`conditions1_${index}`')
                  el-select(v-model='form.jobs[index].active' style='width: 50%; margin-bottom: 10px')
                    el-option(v-for='item in OPTIONS.status', :key='item.value', :label='item.label', :value='item.value')
                  el-input(v-model='form.jobs[index].title' placeholder='タイトルを入力してください ' )
                  el-input(v-model='form.jobs[index].description' placeholder='説明文を入力してください' type='textarea' :rows='3')
                  header.c-form__item__header
                    h2 募集条件
                    .func
                      a(@click='addJobCondition(index)') 追加
                      a(@click='delJobCondition(index)' :disabled='form.jobs[index].conditions.length < 1') 削除
                  .c-form__item__body
                    el-row(:gutter='20')
                      el-col(:span='12' v-for='(i, index2) in form.jobs[index].conditions' :key='`conditions1_${index}`')
                        el-form-item
                          el-input(v-model='form.jobs[index].conditions[index2].title' placeholder='タイトルを入力してください ' )
                          el-input(v-model='form.jobs[index].conditions[index2].body' placeholder='説明文を入力してください' type='textarea' :rows='10' style='margin-bottom: 10px')
              el-col(:span='24')
                p.caption.u-margin__bottom--m 説明文にはマークアップタグを利用できます。
                  br
                  code 例：&lt;a href="https://www.google.com/" class="arrow"&gt;Google&lt;/a&gt;
</template>

<script type='text/javascript'>
import Sticky from '@/components/Element/Sticky'
import UploadMulti from '@/components/Element/Upload/MultiForCareers'
import form from '@/mixins/form'
export default {
  name: 'PagesCareersDetail',
  mixins: [form],
  data () {
    return {
      form: {
        images: [],
        description: '',
        conditions1: [
          {
            title: '',
            body: ''
          }
        ],
        conditions2: [
          {
            title: '',
            body: ''
          }
        ],
        jobs: [
          {
            title: '',
            description: '',
            conditions: [
              {
                title: '',
                body: ''
              }
            ],
            active: 1
          }
        ]
      }
    }
  },
  methods: {
    addCondition (datakey) {
      this.form[datakey].push({
        title: '',
        body: ''
      })
    },
    delCondition (datakey) {
      this.form[datakey].splice(this.form[datakey].length - 1, 1)
    },
    addJobs () {
      this.form.jobs.push({
        title: '',
        description: '',
        conditions: [
          {
            title: '',
            body: ''
          }
        ],
        active: 1
      })
    },
    delJobs () {
      this.form.jobs.splice(this.form.jobs.length - 1, 1)
    },
    addJobCondition (index) {
      this.form.jobs[index].conditions.push({
        title: '',
        body: ''
      })
    },
    delJobCondition (index) {
      if (this.form.jobs[index].conditions.length > 1) {
        this.form.jobs[index].conditions.splice(this.form.jobs[index].conditions.length - 1, 1)
      }
    }
  },
  created () {
    this.init()
  },
  components: {
    Sticky,
    UploadMulti
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Careers/index.vue